import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var ChevronDownSystemIcon = function ChevronDownSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M11.902 16.65L1.282 6.03a.75.75 0 00-1.06 1.06l11.15 11.15a.75.75 0 001.06 0l11.15-11.15a.75.75 0 00-1.06-1.06l-10.62 10.62z"
  }));
};

ChevronDownSystemIcon.displayName = "ChevronDownSystemIcon";
ChevronDownSystemIcon.defaultProps = {
  size: 24
};
ChevronDownSystemIcon.displayName = "ChevronDownSystemIcon";
ChevronDownSystemIcon.iconName = "ChevronDown";
export default ChevronDownSystemIcon;